<template>
  <div 
    class="mt-4">
    <v-layout wrap>
      <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
      <v-flex>
        <section>
          <v-row
            class="pa-4 pb-0 pt-0">
            <v-col
              cols="12" class="pb-1 pt-1">
              <v-card
                flat
                @click="$router.go(-1)"
                  style="cursor: pointer;"
                color="#ffffff">
                <v-card-text>
                  <div
                    class="d-flex align-center">
                    <div
                      class="d-flex align-center">
                      <v-icon
                        size="24"
                        :color="set_color">
                        mdi-backburger
                      </v-icon>
  
                      <div
                        class="fs-16 black--text ml-3"
                        style="font-weight: 600; padding-top: 1px;">
                        {{ $route.meta.title }}
                      </div>
                    </div>
  
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            class="pa-4">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                style="border-radius: 6px;">
                <v-card-text>
                  <ValidationObserver 
                    ref="form">
                    <v-form>
                      <v-row justify="center">
                        <v-col cols="12" md="9" class="py-0">
                          <v-stepper v-model="step_index" flat>
                            <v-stepper-header>
                              <v-stepper-step
                                :complete="step_index > 1"
                                step="1"
                              >
                                Identitas Sekolah
                              </v-stepper-step>
        
                              <v-divider></v-divider>
        
                              <v-stepper-step
                                :complete="step_index > 2"
                                step="2"
                              >
                                Data Kontak
                              </v-stepper-step>
        
                              <v-divider></v-divider>
        
                              <v-stepper-step :complete="step_index > 3" step="3">
                                Data Alamat
                              </v-stepper-step>
        
                              <v-divider></v-divider>
        
                              <v-stepper-step :complete="step_index > 4" step="4">
                                Data Pelengkap
                              </v-stepper-step>
                            </v-stepper-header>

                          </v-stepper>
                        </v-col>
                      </v-row>
                          
                      <v-divider></v-divider>

                      <div class="pa-5">
                        <div step="1" v-if="step_index === 1">
                          <ValidationProvider 
                            name="Nama Sekolah" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div class="fs-13 mb-1">
                              
                              Nama Sekolah
                              <span class="red--text">*</span>
                            </div>
        
                            <v-text-field                            
                              
                              solo
                              rounded
                              dense
        
                              :color="set_color"
                              placeholder="Contoh. SMP xxxxx"
        
                              
        
                              v-model="form.name"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;"
                              class="mb-0">
                            </v-text-field>
                          </ValidationProvider>
  
                          <v-row>
                            <v-col cols="12" md="6" class="py-0">
                              <ValidationProvider 
                                name="Kode NPSN" 
                                rules="required" 
                                v-slot="{ errors }">
                                <div class="fs-13 mb-1">
                                  
                                  Kode NPSN
                                  <span class="red--text">*</span>
                                </div>
            
                                <v-text-field                                
                                  
                                  solo
                                  rounded
                                  dense
                                  type="number"
            
                                  :color="set_color"
                                  placeholder="Kode NPSN"
            
                                  
            
                                  v-model="form.code"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;"
                                  class="mb-0">
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
        
                            <v-col cols="12" md="6" class="py-0">
                              <ValidationProvider 
                                name="Tanggal SK Pendirian" 
                                rules="required" 
                                v-slot="{ errors }">
                                <div class="fs-13 mb-1">
                                  
                                  Tanggal SK Pendirian
                                  <span class="red--text">*</span>
                                </div>
        
                                <v-text-field                                
                                  
                                  solo
                                  rounded
                                  dense
        
                                  :color="set_color"
                                  placeholder="Tanggal SK Pendirian"
                                  type="date"
                                  
        
                                  v-model="form.tgl_pengesahan"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;"
                                  class="mb-0">
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                          </v-row>
  
                          <v-row>
                            <v-col cols="12" md="6" class="py-0">
                              <ValidationProvider 
                                name="Bentuk Pendidikan"
                                rules="required"  
                                v-slot="{ errors }">
                                <div class="fs-13 mb-1">
                                  
                                  Bentuk Pendidikan
                                  <span class="red--text">*</span>
                                </div>
            
                                <v-autocomplete                                
            
                                  solo
                                  rounded
                                  dense
            
                                  :color="set_color"
                                  placeholder="Bentuk Pendidikan"
            
                                  
            
                                  :items="[
                                    {
                                      id: 'paud',
                                      title: 'PAUD'
                                    },
                                    {
                                      id: 'tk',
                                      title: 'TK'
                                    },
                                    {
                                      id: 'tpa',
                                      title: 'TPA'
                                    },
                                    {
                                      id: 'sd',
                                      title: 'SD'
                                    },
                                    {
                                      id: 'mi',
                                      title: 'MI'
                                    },
                                    {
                                      id: 'smp',
                                      title: 'SMP'
                                    },
                                    {
                                      id: 'mts',
                                      title: 'MTS'
                                    },
                                    {
                                      id: 'sma',
                                      title: 'SMA'
                                    },
                                    {
                                      id: 'smk',
                                      title: 'SMK'
                                    },
                                    {
                                      id: 'ma',
                                      title: 'MA'
                                    }
                                  ]"
                                  item-text="title"
                                  item-value="id"
                                  :item-color="set_color"
            
                                  v-model="form.type"
                                  class="mb-0"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                </v-autocomplete>
                              </ValidationProvider>
                            </v-col>
  
  
                            <v-col cols="12" md="6" class="py-0">
                              <ValidationProvider 
                                name="Status Sekolah" 
                                rules="required" 
                                v-slot="{ errors }">
                                <div class="fs-13 mb-1">
                                  
                                  Status Sekolah
                                  <span class="red--text">*</span>
                                </div>
            
                                <v-autocomplete                                
                                  
                                  solo
                                  rounded
                                  dense
            
                                  :color="set_color"
                                  placeholder="Pilih Status Sekolah"
            
                                  item-text="title"
                                  item-value="id"
                                  :items="[
                                    {
                                      id: 'Negeri',
                                      title: 'Negeri'
                                    },
                                    {
                                      id: 'Swasta',
                                      title: 'Swasta'
                                    }
                                  ]"
                                  v-model="form.status"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;"
                                  class="mb-0">
                                </v-autocomplete>
                              </ValidationProvider>
                            </v-col>
                          </v-row>
  
                          <v-row>
                            <v-col cols="12" md="6" class="py-0">
                              <ValidationProvider 
                                name="Status Akreditasi"
                                rules="required"  
                                v-slot="{ errors }">
                                <div class="fs-13 mb-1">
                                  
                                  Status Akreditasi
                                  <span class="red--text">*</span>
                                </div>
            
                                <v-autocomplete                                
            
                                  solo
                                  rounded
                                  dense
            
                                  :color="set_color"
                                  placeholder="Status Akreditasi"
            
                                  
            
                                  :items="[
                                    {
                                      id: 'A',
                                      title: 'A'
                                    },
                                    {
                                      id: 'B',
                                      title: 'B'
                                    },
                                    {
                                      id: 'C',
                                      title: 'C'
                                    },
                                    {
                                      id: 'Belum Terakreditasi',
                                      title: 'Belum Terakreditasi'
                                    }
                                  ]"
                                  item-text="title"
                                  item-value="id"
                                  :item-color="set_color"
            
                                  v-model="form.akreditasi_status"
                                  class="mb-0"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                </v-autocomplete>
                              </ValidationProvider>
                            </v-col>
  
  
                            <v-col cols="12" md="6" class="py-0">
                              <ValidationProvider 
                                name="Status Kepemilikan" 
                                rules="required" 
                                v-slot="{ errors }">
                                <div class="fs-13 mb-1">
                                  
                                  Status Kepemilikan
                                  <span class="red--text">*</span>
                                </div>
            
                                <v-autocomplete                                
                                  
                                  solo
                                  rounded
                                  dense
            
                                  :color="set_color"
                                  placeholder="Pilih Status Kepemilikan"
            
                                  item-text="title"
                                  item-value="id"
                                  :items="[
                                    {
                                      id: 'Pemerintah Daerah',
                                      title: 'Pemerintah Daerah'
                                    },
                                    {
                                      id: 'Pemerintah Pusat',
                                      title: 'Pemerintah Pusat'
                                    },
                                    {
                                      id: 'Yayasan Swasta',
                                      title: 'Yayasan Swasta'
                                    },
                                    {
                                      id: 'Yayasan keagamaan',
                                      title: 'Yayasan keagamaan'
                                    },
                                    {
                                      id: 'Lainnya',
                                      title: 'Lainnya'
                                    }
                                  ]"
                                  v-model="form.kepemilikan_status"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;"
                                  class="mb-0">
                                </v-autocomplete>
                              </ValidationProvider>
                            </v-col>
                          </v-row>

                          <v-row>
                            <v-col cols="12" md="6" class="py-0">
                              <ValidationProvider 
                                name="Jumlah Guru" 
                                rules="required" 
                                v-slot="{ errors }">
                                <div class="fs-13 mb-1">
                                  
                                  Jumlah Guru
                                  <span class="red--text">*</span>
                                </div>
            
                                <v-currency-field                                
                                  
                                  solo
                                  rounded
                                  dense
                                  type="number"
            
                                  :color="set_color"
                                  placeholder="Jumlah Guru"
            
                                  
            
                                  v-model="form.jumlah_guru"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;"
                                  class="mb-0">
                                </v-currency-field>
                              </ValidationProvider>
                            </v-col>
        
                            <v-col cols="12" md="6" class="py-0">
                              <ValidationProvider 
                                name="Jumlah Siswa" 
                                rules="required" 
                                v-slot="{ errors }">
                                <div class="fs-13 mb-1">
                                  
                                  Jumlah Siswa
                                  <span class="red--text">*</span>
                                </div>
        
                                <v-currency-field                                
                                  
                                  solo
                                  rounded
                                  dense
        
                                  :color="set_color"
                                  placeholder="Jumlah Siswa"
                                  type="number"
                                  
        
                                  v-model="form.jumlah_siswa"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;"
                                  class="mb-0">
                                </v-currency-field>
                              </ValidationProvider>
                            </v-col>
                          </v-row>
  
                          <div v-if="form.kepemilikan_status === 'Lainnya'">
                            <ValidationProvider 
                              name="Status Kepemilikan Lainnya" 
                              rules="required" 
                              v-slot="{ errors }">
                              <div class="fs-13 mb-1">
                                
                                Status Kepemilikan Lainnya
                                <span class="red--text">*</span>
                              </div>
          
                              <v-text-field                              
                                
                                solo
                                rounded
                                dense
          
                                :color="set_color"
                                placeholder="Pilih Status Kepemilikan Lainnya"
                                v-model="form.kepemilikan_status_lainnya"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;"
                                class="mb-0">
                              </v-text-field>
                            </ValidationProvider>
                          </div>
  
                          <div>
                            <ValidationProvider 
                              name="Pilih Kurikulum" 
                              rules="required" 
                              v-slot="{ errors }">
                              <div class="fs-13 mb-1">
                                
                                Pilih Kurikulum
                                <span class="red--text">*</span>
                              </div>
          
                              <v-autocomplete                              
                                
                                solo
                                rounded
                                dense
          
                                :color="set_color"
                                :items="kurikulum"
                                item-text="kurikulum_name"
                                item-value="id"
                                placeholder="Pilih Kurikulum"
                                v-model="form.kurikulum_id"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;"
                                class="mb-0">
                              </v-autocomplete>
                            </ValidationProvider>
                          </div>
                        </div>
  
                        <div step="2" v-if="step_index === 2">


                          <v-row>
                            <v-col cols="12" md="6" class="py-0">
                              <ValidationProvider 
                                name="Email Sekolah" 
                                rules="email" 
                                v-slot="{ errors }">
                                <div class="fs-13 mb-1">
                                  
                                  Email Sekolah
                                </div>
        
                                <v-text-field
                                  v-on:keyup.enter="save()"
                                  
                                  solo
                                  rounded
                                  dense
        
                                  :color="set_color"
                                  placeholder="Contoh. SMP@xxxx.xx"
        
                                  
        
                                  v-model="form.email"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;"
                                  class="mb-0">
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
        
                            <v-col cols="12" md="6" class="py-0">
                              <ValidationProvider 
                                name="No Telephone Sekolah" 
                                rules="min:9|max:13" 
                                v-slot="{ errors }">
                                <div class="fs-13 mb-1">
                                  
                                  No Telephone Sekolah
                                </div>
        
                                <v-text-field
                                  v-on:keyup.enter="save()"
                                  
                                  solo
                                  rounded
                                  dense
                                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                  type="number"
                                  min="0"
        
                                  :color="set_color"
                                  placeholder="Contoh. xxxxxxxxxx"
        
                                  
        
                                  v-model="form.phone_number"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;"
                                  class="mb-0">
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
        
                            <v-col cols="12" md="6" class="py-0">
                              <ValidationProvider 
                                name="Website Sekolah" 
                                rules="" 
                                v-slot="{ errors }">
                                <div class="fs-13 mb-1">
                                  
                                  Website Sekolah
                                  <!-- <span class="red--text">*</span> -->
                                </div>
        
                                <v-text-field
                                  v-on:keyup.enter="save()"
                                  
                                  solo
                                  rounded
                                  dense
        
                                  :color="set_color"
                                  placeholder="Contoh. SMP@xxxx.xx"
        
                                  
        
                                  v-model="form.website"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;"
                                  class="mb-0">
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                          </v-row>
                          <v-divider class="pb-4"></v-divider>

                          <div class="fs-15 font_weight_600 mb-3 grey--text text--darken-3 mt-2 d-flex">
                            <div>
                              Data Kepala Sekolah
                            </div>

                            <div class="ml-auto">
                              <v-btn
                                @click="updateKepala()"
                                color="primary"
                                elevation="0"
                                small
                                class="white--text text-capitalize"
                                style="border-radius: 6px;">
                                Ubah Kepala Sekolah
                              </v-btn>
                            </div>

                          </div>
                          <v-row>
                            <v-col cols="12" md="6" class="py-0">
                              <ValidationProvider 
                                name="Nama Kepala Sekolah" 
                                rules="required" 
                                v-slot="{ errors }">
                                <div class="fs-13 mb-1">
                                  
                                  Nama Kepala Sekolah
                                  <span class="red--text">*</span>
                                </div>
            
                                <v-text-field                                
                                  
                                  solo
                                  rounded
                                  dense
            
                                  :color="set_color"
                                  placeholder="Nama Kepala Sekolah"
            
                                  
            
                                  v-model="form.kepala_sekolah_name"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;"
                                  class="mb-0">
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="12" md="6" class="py-0">
                              <ValidationProvider 
                                name="Email Kepala Sekolah" 
                                rules="email" 
                                v-slot="{ errors }">
                                <div class="fs-13 mb-1">
                                  
                                  Email Kepala Sekolah
                                </div>
            
                                <v-text-field                                
                                  
                                  solo
                                  rounded
                                  dense
            
                                  :color="set_color"
                                  placeholder="Email Kepala Sekolah"
            
                                  
            
                                  v-model="form.kepala_sekolah_email"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;"
                                  class="mb-0">
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>

                            <v-col cols="12" md="6" class="py-0">
                              <ValidationProvider 
                                name="Nomor Telepon Kepala Sekolah" 
                                rules="required|min:9|max:13" 
                                v-slot="{ errors }">
                                <div class="fs-13 mb-1">
                                  
                                  Nomor Telepon Kepala Sekolah
                                  <span class="red--text">*</span>
                                </div>
        
                                <v-text-field                                
                                  
                                  solo
                                  rounded
                                  dense
                                  prefix="+62"
                                  type="number"
        
                                  :color="set_color"
                                  placeholder="Contoh. 85xxxxxxxx"
        
                                  v-model="form.kepala_sekolah_mobile_phone_number"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;"
                                  class="mb-0">
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>

                            <v-col cols="12" md="6" class="py-0">
                              <ValidationProvider 
                                name="Tanggal Mulai Menjabat" 
                                rules="required" 
                                v-slot="{ errors }">
                                <div class="fs-13 mb-1">
                                  
                                  Tanggal Mulai Menjabat
                                  <span class="red--text">*</span>
                                </div>
        
                                <v-text-field                                
                                  
                                  solo
                                  rounded
                                  dense
                                  type="date"
        
                                  :color="set_color"
                                  placeholder="Pilih Tanggal"
        
                                  v-model="form.kepala_sekolah_jabatan_tmt"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;"
                                  class="mb-0">
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>

                            <v-col cols="12" class="py-0">
                              <ValidationProvider 
                                name="Alamat Kepala Sekolah" 
                                rules="required" 
                                v-slot="{ errors }">
                                <div class="fs-13 mb-1">
                                  
                                  Alamat Kepala Sekolah
                                  <span class="red--text">*</span>
                                </div>
            
                                <v-textarea
                                  v-on:keyup.enter="save()"
                                  
                                  solo
                                  rounded
                                  dense
            
                                  :color="set_color"
                                  placeholder="Contoh. Jl. xxxxxxx"
            
                                  v-model="form.kepala_sekolah_address"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;"
                                  class="mb-0">
                                </v-textarea>
                              </ValidationProvider>
                            </v-col>
                          </v-row>
                          <v-divider class="pb-4"></v-divider>

                          <div class="fs-15 font_weight_600 mb-3 grey--text text--darken-3 mt-2 d-flex">
                            <div>
                              Data Operator Sekolah
                            </div>

                            <div class="ml-auto">
                              <v-btn
                                @click="updateOperator()"
                                color="primary"
                                elevation="0"
                                small
                                class="white--text text-capitalize"
                                style="border-radius: 6px;">
                                Ubah Operator
                              </v-btn>
                            </div>

                          </div>
                          <v-row>
                            <v-col cols="12" md="6" class="py-0">
                              <ValidationProvider 
                                name="Nama Operator Sekolah" 
                                rules="required" 
                                v-slot="{ errors }">
                                <div class="fs-13 mb-1">
                                  
                                  Nama Operator Sekolah
                                  <span class="red--text">*</span>
                                </div>
            
                                <v-text-field                                
                                  
                                  solo
                                  rounded
                                  dense
            
                                  :color="set_color"
                                  placeholder="Nama Operator Sekolah"
            
                                  
            
                                  v-model="form.operator_sekolah_name"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;"
                                  class="mb-0">
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="12" md="6" class="py-0">
                              <ValidationProvider 
                                name="Email Operator Sekolah" 
                                rules="email" 
                                v-slot="{ errors }">
                                <div class="fs-13 mb-1">
                                  
                                  Email Operator Sekolah
                                </div>
            
                                <v-text-field                                
                                  
                                  solo
                                  rounded
                                  dense
            
                                  :color="set_color"
                                  placeholder="Email Operator Sekolah"
            
                                  
            
                                  v-model="form.operator_sekolah_email"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;"
                                  class="mb-0">
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>

                            <v-col cols="12" md="6" class="py-0">
                              <ValidationProvider 
                                name="Nomor Telepon Operator Sekolah" 
                                rules="required|min:9|max:13" 
                                v-slot="{ errors }">
                                <div class="fs-13 mb-1">
                                  
                                  Nomor Telepon Operator Sekolah
                                  <span class="red--text">*</span>
                                </div>
        
                                <v-text-field                                
                                  
                                  solo
                                  rounded
                                  dense
                                  type="number"
                                  prefix="+62"
        
                                  :color="set_color"
                                  placeholder="Contoh. 85xxxxxxxx"
        
                                  v-model="form.operator_sekolah_mobile_phone_number"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;"
                                  class="mb-0">
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>

                            <v-col cols="12" md="6" class="py-0">
                              <ValidationProvider 
                                name="Tanggal Mulai Menjabat" 
                                rules="required" 
                                v-slot="{ errors }">
                                <div class="fs-13 mb-1">
                                  
                                  Tanggal Mulai Menjabat
                                  <span class="red--text">*</span>
                                </div>
        
                                <v-text-field                                
                                  
                                  solo
                                  rounded
                                  dense
                                  type="date"
        
                                  :color="set_color"
                                  placeholder="Pilih Tanggal"
        
                                  v-model="form.operator_sekolah_jabatan_tmt"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;"
                                  class="mb-0">
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>

                            <v-col cols="12" class="py-0">
                              <ValidationProvider 
                                name="Alamat Operator Sekolah" 
                                rules="required" 
                                v-slot="{ errors }">
                                <div class="fs-13 mb-1">
                                  
                                  Alamat Operator Sekolah
                                  <span class="red--text">*</span>
                                </div>
            
                                <v-textarea
                                  v-on:keyup.enter="save()"
                                  
                                  solo
                                  rounded
                                  dense
            
                                  :color="set_color"
                                  placeholder="Contoh. Jl. xxxxxxx"
            
                                  v-model="form.operator_sekolah_address"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;"
                                  class="mb-0">
                                </v-textarea>
                              </ValidationProvider>
                            </v-col>
                          </v-row>
                          <v-divider class="pb-4"></v-divider>

                          <div class="fs-15 font_weight_600 mb-3 grey--text text--darken-3 mt-2 d-flex">
                            <div>
                              Data Pendamping Sekolah
                            </div>

                            <div class="ml-auto">
                              <v-btn
                                @click="updateAdmin()"
                                color="primary"
                                elevation="0"
                                small
                                class="white--text text-capitalize"
                                style="border-radius: 6px;">
                                Ubah Pendamping
                              </v-btn>
                            </div>

                          </div>
                          <v-row>
                            <v-col cols="12" md="6" class="py-0">
                              <ValidationProvider 
                                name="Nama Pendamping Sekolah" 
                                rules="required" 
                                v-slot="{ errors }">
                                <div class="fs-13 mb-1">
                                  
                                  Nama Pendamping Sekolah
                                  <span class="red--text">*</span>
                                </div>
            
                                <v-text-field                                
                                  
                                  solo
                                  rounded
                                  dense
            
                                  :color="set_color"
                                  placeholder="Nama Pendamping Sekolah"
            
                                  
            
                                  v-model="form.admin_name"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;"
                                  class="mb-0">
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="12" md="6" class="py-0">
                              <ValidationProvider 
                                name="Email Pendamping Sekolah" 
                                rules="email" 
                                v-slot="{ errors }">
                                <div class="fs-13 mb-1">
                                  
                                  Email Pendamping Sekolah
                                </div>
            
                                <v-text-field                                
                                  
                                  solo
                                  rounded
                                  dense
            
                                  :color="set_color"
                                  placeholder="Email Pendamping Sekolah"
            
                                  
            
                                  v-model="form.admin_email"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;"
                                  class="mb-0">
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>

                            <v-col cols="12" md="6" class="py-0">
                              <ValidationProvider 
                                name="Nomor Telepon Pendamping Sekolah" 
                                rules="required|min:9|max:13" 
                                v-slot="{ errors }">
                                <div class="fs-13 mb-1">
                                  
                                  Nomor Telepon Pendamping Sekolah
                                  <span class="red--text">*</span>
                                </div>
        
                                <v-text-field                                
                                  
                                  solo
                                  rounded
                                  dense
                                  prefix="+62"
                                  type="number"
        
                                  :color="set_color"
                                  placeholder="Contoh. 85xxxxxxxx"
        
                                  v-model="form.admin_mobilephone"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;"
                                  class="mb-0">
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                          </v-row>
                        </div>
  
                        <div step="3" v-if="step_index === 3">
                          <v-row>
                            <v-col cols="12" md="6" class="py-0">
                              <ValidationProvider 
                                name="Provinsi"
                                rules="required"  
                                v-slot="{ errors }">
                                <div class="fs-13 mb-1">
                                  
                                  Provinsi
                                  <span class="red--text">*</span>
                                </div>
            
                                <v-autocomplete
                                  v-on:keyup.enter="save()"
            
                                  solo
                                  rounded
                                  dense
            
                                  :color="set_color"
                                  placeholder="Pilih Provinsi"
            
                                  
            
                                  :items="province"
                                  v-on:change="changeProvince()"
                                  item-value="id"
                                  item-text="name"
                                  :item-color="set_color"
            
                                  v-model="form.province_id"
                                  class="mb-0"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                </v-autocomplete>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="12" md="6" class="py-0">
                              <ValidationProvider 
                                name="Kota / Kabupaten"
                                rules="required"  
                                v-slot="{ errors }">
                                <div class="fs-13 mb-1">
                                  
                                  Kota / Kabupaten
                                  <span class="red--text">*</span>
                                </div>
            
                                <v-autocomplete
                                  v-on:keyup.enter="save()"
            
                                  solo
                                  rounded
                                  dense
            
                                  :color="set_color"
                                  placeholder="Pilih Kota / Kabupaten"
            
                                  
            
                                  :items="city"
                                  v-on:change="changeCity()"
                                  item-value="id"
                                  item-text="name"
                                  :item-color="set_color"
            
                                  v-model="form.city_id"
                                  class="mb-0"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                </v-autocomplete>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="12" md="6" class="py-0">
                              <ValidationProvider 
                                name="Kecamatan"
                                rules="required"  
                                v-slot="{ errors }">
                                <div class="fs-13 mb-1">
                                  
                                  Kecamatan
                                  <span class="red--text">*</span>
                                </div>
            
                                <v-autocomplete
                                  v-on:keyup.enter="save()"
            
                                  solo
                                  rounded
                                  dense
            
                                  :color="set_color"
                                  v-on:change="changeSub()"
                                  placeholder="Pilih Kecamatan"
            
                                  
            
                                  :items="subdistrict"
                                  item-value="id"
                                  item-text="name"
                                  :item-color="set_color"
            
                                  v-model="form.subdistrict_id"
                                  class="mb-0"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                </v-autocomplete>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="12" md="6" class="py-0">
                              <ValidationProvider 
                                name="Kelurahan"
                                rules="required"  
                                v-slot="{ errors }">
                                <div class="fs-13 mb-1">
                                  
                                  Kelurahan
                                  <span class="red--text">*</span>
                                </div>
            
                                <v-autocomplete
                                  v-on:keyup.enter="save()"
            
                                  solo
                                  rounded
                                  dense
            
                                  :color="set_color"
                                  placeholder="Pilih Kelurahan"
            
                                  :items="village"
                                  v-on:change="village.filter(item =>item.id === form.village_id).map(item => form.village_name = item.name)"
                                  item-value="id"
                                  item-text="name"
                                  :item-color="set_color"
            
                                  v-model="form.village_id"
                                  class="mb-0"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                </v-autocomplete>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="12" md="6" class="py-0">
                              <ValidationProvider 
                                name="RT/RW" 
                                rules="" 
                                v-slot="{ errors }">
                                <div class="fs-13 mb-1">
                                  
                                  RT/RW
                                </div>
            
                                <v-text-field
                                  v-on:keyup.enter="save()"
                                  
                                  solo
                                  rounded
                                  dense
            
                                  :color="set_color"
                                  placeholder="Contoh. 20/07"
            
                                  v-model="form.rt_rw"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;"
                                  class="mb-0">
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>
                          </v-row>

                          <ValidationProvider 
                            name="Alamat" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div class="fs-13 mb-1">
                              
                              Alamat
                              <span class="red--text">*</span>
                            </div>
        
                            <v-textarea
                              v-on:keyup.enter="save()"
                              
                              solo
                              rounded
                              dense
        
                              :color="set_color"
                              placeholder="Contoh. Jl. xxxxxxx"
        
                              v-model="form.address"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;"
                              class="mb-0">
                            </v-textarea>
                          </ValidationProvider>

                          <div
                            class="mb-6" v-if="!process.load">
                            <div 
                              class="body-2 mb-2">
                              Silahkan geser marker untuk menentukan koordinat lokasi dibawah ini:
                            </div>
        
                            <label>
                              <gmap-autocomplete
                                placeholder="ketik alamat"
                                class="style-auto-map mb-4"
                                @place_changed="setPlace">
                              </gmap-autocomplete>
                            </label>
        
                            <gmap-map
                              :center="center"
                              :zoom="12"
                              :options="{
                                zoomControl: true,
                                mapTypeControl: false,
                                scaleControl: false,
                                streetViewControl: false,
                                rotateControl: false,
                                fullscreenControl: true,
                                disableDefaultUi: false
                              }"
                              :clickable="true"
                              @click="updatePlace"
                              style="width: 100%; height: 300px;">
        
                              <gmap-marker
                                :position="center"
                                :draggable="true"
                                @drag="updatePlace"
                                @click="center=center">
                              </gmap-marker>
                            </gmap-map>
                          </div>
                        </div>

                        <div step="4" v-if="step_index === 4">
                          <ValidationProvider 
                            name="NPWP" 
                            rules="" 
                            v-slot="{ errors }">
                            <div class="fs-13 mb-1">
                              
                              NPWP
                            </div>
    
                            <v-text-field                                
                              
                              solo
                              rounded
                              dense
                              type="number"
    
                              :color="set_color"
                              placeholder="Contoh. 23385xxxxxxxx"
    
                              v-model="form.npwp"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;"
                              class="mb-0">
                            </v-text-field>
                          </ValidationProvider>

                          <v-card 
                            flat
                            class="mb-5">
                            <v-card-text class="px-1 py-0">
                              <div cclass="fs-13">
                                Upload Logo
                              </div>
                              <v-row>
                                <v-col class="pb-0" cols="4">
                                  <uploadfolder
                                    v-model="upload.image" 
                                    style="height: 200px; width: 100%">
                                    <div 
                                      slot="activator"
                                      class="cursor-pointer">
                                      <v-card 
                                        flat
                                        height="200"
                                        class="d-flex align-center justify-center"
                                        style="border-radius: 15px;
                                              border: 2px solid #eaeaea; 
                                              border-style: dashed;">
                                        <div v-if="form.logo_url.length < 1">
                                          <v-icon v-if="!process.image"
                                            size="50" 
                                            color="#868b93">
                                            mdi-plus-circle-outline
                                          </v-icon>
                  
                                          <v-progress-circular v-else
                                            indeterminate
                                            :color="set_color">
                                          </v-progress-circular>
                                        </div>
                  
                                        <v-img v-else
                                          contain
                                          height="200"
                                          :src="form.logo_url" 
                                          :alt="form.logo_url"
                                          class="text-center d-flex align-center">
                                          <div 
                                            class="d-flex aling-center justify-center" 
                                            style="width: 100%; height: auto;">
                                            <v-icon v-if="!process.image"
                                              size="50" 
                                              color="white">
                                              mdi-plus-circle-outline
                                            </v-icon>
                  
                                            <v-progress-circular v-else
                                              indeterminate
                                              :color="set_color">
                                            </v-progress-circular>
                                          </div>
                                        </v-img>
                                      </v-card>
                                    </div>
                                  </uploadfolder>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>


                          <v-card 
                            flat
                            class="mb-5">
                            <v-card-text class="px-1 py-0">
                              <div cclass="fs-13">
                                Upload Foto Sampul / Banner
                              </div>
                              <v-row>
                                <v-col class="pb-0" cols="12">
                                  <uploadfolder
                                    v-model="upload.banner_url" 
                                    style="height: 250px; width: 100%">
                                    <div 
                                      slot="activator"
                                      class="cursor-pointer">
                                      <v-card 
                                        flat
                                        height="250"
                                        class="d-flex align-center justify-center"
                                        style="border-radius: 15px;
                                              border: 2px solid #eaeaea; 
                                              border-style: dashed;">
                                        <div v-if="form.banner_url.length < 1">
                                          <v-icon v-if="!process.banner_url"
                                            size="50" 
                                            color="#868b93">
                                            mdi-plus-circle-outline
                                          </v-icon>
                  
                                          <v-progress-circular v-else
                                            indeterminate
                                            :color="set_color">
                                          </v-progress-circular>
                                        </div>
                  
                                        <v-img v-else
                                          contain
                                          height="250"
                                          :src="form.banner_url" 
                                          :alt="form.banner_url"
                                          class="text-center d-flex align-center">
                                          <div 
                                            class="d-flex aling-center justify-center" 
                                            style="width: 100%; height: auto;">
                                            <v-icon v-if="!process.banner_url"
                                              size="50" 
                                              color="white">
                                              mdi-plus-circle-outline
                                            </v-icon>
                  
                                            <v-progress-circular v-else
                                              indeterminate
                                              :color="set_color">
                                            </v-progress-circular>
                                          </div>
                                        </v-img>
                                      </v-card>
                                    </div>
                                  </uploadfolder>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>

                          <ValidationProvider 
                            name="Deskripsi Banner" 
                            rules="" 
                            v-slot="{ errors }">
                            <div class="fs-13 mb-1">
                              
                              Deskripsi Banner
                            </div>
    
                            <v-textarea                                
                              rows="2"
                              solo
                              rounded
                              dense
    
                              :color="set_color"
                              placeholder="Deskripsi Banner"
    
                              v-model="form.banner_desc"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;"
                              class="mb-0">
                            </v-textarea>
                          </ValidationProvider>

                          <v-card 
                            flat
                            class="mb-5">
                            <v-card-text class="px-1 py-0">
                              <div cclass="fs-13">
                                Upload Foto Sekolah
                              </div>
                              <v-row>
                                <v-col class="pb-0" cols="12" md="3" v-for="(item, index) in form.galery_array" :key="index">
                                  <v-img
                                    contain
                                    height="200"
                                    style="border-radius: 15px;
                                              border: 2px solid #eaeaea; 
                                              border-style: dashed;"
                                    :src="item.galery_url" 
                                    :alt="item.galery_url"
                                    class="text-center d-flex align-center">
                                    <div 
                                      class="d-flex aling-center justify-center" 
                                      style="width: 100%; height: auto;">
                                    </div>
                                    <div 
                                      @click="form.galery_array.splice(index, 1)"
                                      class="cursor-pointer"
                                      style="position: absolute; top: 5px; right: 5px;">
                                      <v-icon size="24" color="red">mdi-close-circle</v-icon>
                                    </div>
                                  </v-img>
                                </v-col>
                                <v-col class="pb-0" cols="12" md="3">
                                  <uploadfolder
                                    v-model="upload.galery_array" 
                                    style="height: 200px; width: 100%">
                                    <div 
                                      slot="activator"
                                      class="cursor-pointer">
                                      <v-card 
                                        flat
                                        height="200"
                                        class="d-flex align-center justify-center"
                                        style="border-radius: 15px;
                                              border: 2px solid #eaeaea; 
                                              border-style: dashed;">
                                        <div>
                                          <v-icon v-if="!process.galery_array"
                                            size="50" 
                                            color="#868b93">
                                            mdi-plus-circle-outline
                                          </v-icon>
                  
                                          <v-progress-circular v-else
                                            indeterminate
                                            :color="set_color">
                                          </v-progress-circular>
                                        </div>
                                      </v-card>
                                    </div>
                                  </uploadfolder>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>


                          <div>
                            <div class="fs-15 font_weight_600 mb-3 grey--text text--darken-3 mt-2">
                              Data Rekening
                            </div>
                            <v-btn
                              color="#4B4B4B"
                              elevation="0"
                              small
                              @click="form.rekening_array.push({rekening_bank_name: '', rekening_number: '', rekening_atas_nama: '', rekening_cabang_kcp: ''})"
                              :disabled="process.form"
                              min-height="30"
                              class="fs-12 white--text text-capitalize d-flex align-center mb-1"
                              style="border-radius: 6px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                              <span
                                class="ml-2 ">
                                Tambah Rekening
                              </span>
                            </v-btn>
                            <table style="border: 1px solid #ededed; width: 100%; border-collapse: collapse;">
                              <tr>
                                <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                                  Aksi
                                </th>
                                <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 200px; min-width: 200px; max-width: 200px;" class="black--text">
                                  Nama Bank
                                </th>
                                <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 200px; min-width: 200px; max-width: 200px;" class="black--text">
                                  Nomer Rekening
                                </th>
                                <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 200px; min-width: 200px; max-width: 200px;" class="black--text">
                                  Nama Rekening
                                </th>
                                <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 100%;" class="black--text">
                                  Cabang KCP/Unit
                                </th>
                              </tr>
                              <tr v-for="(item, index) in form.rekening_array" :key="index">
                                <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                                  <v-tooltip 
                                    top>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        @click="form.rekening_array.splice(index, 1)"
                                        
                                        v-bind="attrs"
                                        v-on="on"
                                        
                                        min-width="24" min-height="24"
                                        x-small
                                        rounded
                                        color="red"
                                        elevation="0"
                                        class="white--text text-capitalize mx-1 px-0"
                                        style="font-weight: 600; border-radius: 6px;">
                                        <v-icon size="15">mdi-trash-can-outline</v-icon>
                                      </v-btn>
                                    </template>

                                    <span>Hapus</span>
                                  </v-tooltip>
                                </td>
                                <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 200px; min-width: 200px; max-width: 200px;" class="black--text">
                                  <ValidationProvider 
                                    :name="`Nama Bank ${index + 1}`" 
                                    rules="required" 
                                    v-slot="{ errors }">
                
                                    <v-autocomplete
                                      solo
                                      rounded
                                      dense
                
                                      :color="set_color"
                                      placeholder="Nama Bank"
                                      v-model="item.rekening_bank_name"
                                      :items="[
                                        {
                                          id: 'BCA',
                                          name: 'BCA'
                                        },
                                        {
                                          id: 'BRI',
                                          name: 'BRI'
                                        },
                                        {
                                          id: 'BNI',
                                          name: 'BNI'
                                        },
                                        {
                                          id: 'Mandiri',
                                          name: 'Mandiri'
                                        },
                                        {
                                          id: 'BTN',
                                          name: 'BTN'
                                        },
                                        {
                                          id: 'CIMB Niaga',
                                          name: 'CIMB Niaga'
                                        },
                                        {
                                          id: 'Bank Jateng',
                                          name: 'Bank Jateng'
                                        },
                                        {
                                          id: 'Bank Jatim',
                                          name: 'Bank Jatim'
                                        }
                                      ]"
                                      item-text="name"
                                      item-value="id"
                                      :error-messages="errors"
                                      required
                                      class="mb-0"
                                      style="border-radius: 10px;">
                                    </v-autocomplete>
                                  </ValidationProvider>
                                </td>
                                <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 300px; min-width: 300px; max-width: 300px;" class="black--text">
                                  <ValidationProvider 
                                    :name="`Nomer Rekening ${index + 1}`" 
                                    rules="required" 
                                    v-slot="{ errors }">
                
                                    <v-text-field
                                      solo
                                      rounded
                                      dense
                                      type="number"
                                      min="0"
                                      :color="set_color"
                                      placeholder="Nomer Rekening"
                                      v-model="item.rekening_number"
                                      :error-messages="errors"
                                      required
                                      class="mb-0"
                                      style="border-radius: 10px;">
                                    </v-text-field>
                                  </ValidationProvider>
                                </td>
                                <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 250px; min-width: 250px; max-width: 250px;" class="black--text">
                                  <ValidationProvider 
                                    :name="`Nama Rekening ${index + 1}`" 
                                    rules="required" 
                                    v-slot="{ errors }">
                
                                    <v-text-field
                                      solo
                                      rounded
                                      dense
                
                                      :color="set_color"
                                      placeholder="Nama Rekening"
                                      v-model="item.rekening_atas_nama"
                                      :error-messages="errors"
                                      required
                                      class="mb-0"
                                      style="border-radius: 10px;">
                                    </v-text-field>
                                  </ValidationProvider>
                                </td>
                                <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 100%;" class="black--text">
                                  <ValidationProvider 
                                    :name="`Cabang KCP/Unit ${index + 1}`" 
                                    rules="required" 
                                    v-slot="{ errors }">
                
                                    <v-text-field
                                      solo
                                      rounded
                                      dense
                
                                      :color="set_color"
                                      placeholder="Cabang KCP/Unit"
                                      v-model="item.rekening_cabang_kcp"
                                      :error-messages="errors"
                                      required
                                      class="mb-0"
                                      style="border-radius: 10px;">
                                    </v-text-field>
                                  </ValidationProvider>
                                </td>
                              </tr>
                            </table>

                            <v-card-text
                              v-if="form.rekening_array.length === 0"
                              class="pb-0 mb-4" style="height: 200px; display: flex; align-items: center; justify-content: center; border: 1px solid #eee; border-top: none;">
                              <div class="text-center">
                                <div class="mt-3 fs-16">
                                  Belum ada data
                                </div>
                              </div>
                            </v-card-text>
                          </div>
                        </div>
                      </div>
                    </v-form>
                  </ValidationObserver>
                  <div v-if="message.error.length > 0"
                    class="text-left mt-0">
                    <div
                      class="error--text d-flex align-start">
                      <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                      
                      <span
                        class="ml-1">
                        {{ message.error }}
                      </span>
                    </div>
                  </div>
                </v-card-text>
                <v-card-actions class="pa-5">
                  <v-btn
                    @click="step_index = step_index - 1"
                    :disabled="process.form"
                    elevation="0"
                    :color="set_color"
                    dark
                    v-if="step_index > 1"
                    rounded
                    class="white--text text-capitalize"
                    style="border-radius: 6px;">
                    Sebelumnya
                  </v-btn>
                  <v-spacer/>
                  <v-btn
                    @click="toNextStep()"
                    :disabled="process.form"
                    elevation="0"
                    :color="set_color"
                    dark
                    v-if="step_index < 4"
                    rounded
                    class="white--text text-capitalize"
                    style="border-radius: 6px;">
                    Selanjutnya
                  </v-btn>

                  <v-btn
                    @click="save()"
                    :disabled="process.form"
                    dark
                    v-if="step_index === 4"
                    elevation="0"
                    :color="set_color"
                    class="white--text text-capitalize"
                    style="border-radius: 6px;">
                    Simpan
                  </v-btn>

                  <v-btn
                    to="/sekolah/data-sekolah"
                    :disabled="process.form"
                    width="85"
                    outlined
                    elevation="0"
                    color="red"
                    style="border-radius: 6px;"
                    class="fs-13 font-weight-bold text-capitalize white--text">
                    Batal
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import axios from "axios";
  import moment from "moment"
  import "moment/locale/id"
import router from "../../../../../router";
  export default {
    data () {
      return {
        dialog: {
          snackbar: false,
        },
        filter: {
          school_id: '',
        },
        step_index: 1,
        form: {
          id: '',
          name: '',
          code: '',
          status: '',
          type: '',
          kepemilikan_status: '',
          akreditasi_status: '',
          kepemilikan_status_lainnya: '',
          province_id: '',
          city_id: '',
          subdistrict_id: '',
          province_name: '',
          city_name: '',
          subdistrict_name: '',
          village_id:'',
          village_name: '',
          rt_rw: '',
          address: '',
          latitude: '',
          longitude: '',
          phone_number: '',
          email: '',
          website: '',
          tgl_pengesahan: '',
          desc: '',
          logo_url: '',
          admin_name: '',
          admin_email: '',
          admin_mobilephone: '',
          kurikulum_id: 0,
          kepala_sekolah_name: '',
          kepala_sekolah_mobile_phone_number: '',
          kepala_sekolah_address: '',
          kepala_sekolah_email: '',
          kepala_sekolah_jabatan_tmt: '',
          operator_sekolah_name: '',
          operator_sekolah_mobile_phone_number: '',
          operator_sekolah_address: '',
          operator_sekolah_email: '',
          operator_sekolah_jabatan_tmt: '',
          operator_sekolah_email: '',
          banner_url: '',
          banner_desc: '',
          galery_array: [],
          npwp: '',
          rekening_array: [],
          jumlah_guru: '',
          jumlah_siswa: '',
        },

        kepala_sekolah_id: '',
        operator_pegawai_id: '',
        admin_pendamping_id: '',
        center: {
          lat: -7.703889, 
          lng: 110.60166
        },
        
        upload: {
          image: '',
          banner_url: null,
          galery_array: null
        },
        province: [],
        city: [],
        subdistrict: [],
        school: [],
        village: [],
        kurikulum: [],

        process: {
          load: true,
          image: false,
          form: false,
          banner_url: false,
          galery_array: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
    },
    watch: {
      'upload.image': {
        handler: function () {
          if (this.upload.image) {
            this.process.image = this.upload.image.process

            if (!this.process.image) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.form.logo_url = this.upload.image.fileuri

              // this.save_image()
            }
          }
        },
        deep: true
      },
      'upload.banner_url': {
        handler: function () {
          if (this.upload.banner_url) {
            this.process.banner_url = this.upload.banner_url.process

            if (!this.process.banner_url) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.form.banner_url = this.upload.banner_url.fileuri

              // this.save_image()
            }
          }
        },
        deep: true
      },
      'upload.galery_array': {
        handler: function () {
          if (this.upload.galery_array) {
            this.process.galery_array = this.upload.galery_array.process

            if (!this.process.galery_array) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.form.galery_array.push({
                galery_url: this.upload.galery_array.fileuri,
                galery_desc: ''
              })

              // this.save_image()

              this.upload.galery_array = null
            }
          }
        },
        deep: true
      },
      // 'options': {
      //   handler () {
      //     let pagination = { row: this.limit, page: 1 }
          
      //     this.fetch(pagination)
      //   },
      //   deep: true
      // }
    },
    computed: {
      token () {
        return this.$store.state.token
      },
      user () {
        this.filter.school_id = this.$store.state.user.school_id === undefined || this.$store.state.user.school_id === null ? this.$store.state.school !== undefined && this.$store.state.school !== null && this.$store.state.school !== '' ? this.$store.state.school : '' : this.$store.state.user.school_id
        return this.$store.state.user
      },
      set_color () {
        return this.$store.state.color
      }
    },
    mounted () {
      this.fetchDetail()
      this.fetchKurikulum()
      this.fetchProv()
    },
    methods: {
      async fetchDetail() {
          this.process.load = true
         let params = {
          id: this.$route.params.id
        }
        let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? 'pegawai/school/detail' : 'school/detail'

        await get(`${url}`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            // this.kurikulum = res.results.data
            this.form = {
              id: res.results.data.id,
              name: res.results.data.name,
              code: res.results.data.code,
              status: res.results.data.status,
              type: res.results.data.type,
              kepemilikan_status: res.results.data.kepemilikan_status,
              akreditasi_status: res.results.data.akreditasi_status,
              kepemilikan_status_lainnya: res.results.data.kepemilikan_status_lainnya,
              province_id: res.results.data.province_id,
              province_name: res.results.data.province_name,
              city_id: res.results.data.city_id,
              city_name: res.results.data.city_name,
              subdistrict_id: res.results.data.subdistrict_id,
              subdistrict_name: res.results.data.subdistrict_name,
              village_id: res.results.data.village_id,
              village_name: res.results.data.village_name,
              rt_rw: res.results.data.rt_rw,
              address: res.results.data.address,
              latitude: res.results.data.latitude*1,
              longitude: res.results.data.longitude*1,
              phone_number: res.results.data.phone_number,
              email: res.results.data.email,
              website: res.results.data.website,
              tgl_pengesahan: res.results.data.tgl_pengesahan,
              desc: res.results.data.desc,
              logo_url: res.results.data.logo_url,
              admin_name: res.results.data.admin_pendamping[0].admin_name,
              admin_email: res.results.data.admin_pendamping[0].admin_email,
              admin_mobilephone: res.results.data.admin_pendamping[0].admin_mobilephone.replace('62', ''),
              kurikulum_id: res.results.data.kurikulum_id,
              kepala_sekolah_name: res.results.data.kepala_pegawai_name,
              kepala_sekolah_mobile_phone_number: res.results.data.kepala_pegawai_mobile_phone_number.replace('62', ''),
              kepala_sekolah_address: res.results.data.kepala_pegawai_address,
              kepala_sekolah_email: res.results.data.kepala_pegawai_email,
              kepala_sekolah_jabatan_tmt: res.results.data.kepala_pegawai_jabatan_tmt,
              operator_sekolah_name: res.results.data.operator_pegawai_name,
              operator_sekolah_mobile_phone_number: res.results.data.operator_pegawai_mobile_phone_number.replace('62', ''),
              operator_sekolah_address: res.results.data.operator_pegawai_address,
              operator_sekolah_email: res.results.data.operator_pegawai_email,
              operator_sekolah_jabatan_tmt: res.results.data.operator_pegawai_jabatan_tmt,
              operator_sekolah_email: res.results.data.operator_pegawai_email,
              banner_url: res.results.data.school_banner_url,
              banner_desc: res.results.data.school_banner_desc,
              galery_array: [],
              npwp: res.results.data.npwp,
              rekening_array: [],
              jumlah_guru: res.results.data.jumlah_guru,
              jumlah_siswa: res.results.data.jumlah_siswa,
            }

            this.form.kepemilikan_status = res.results.data.kepemilikan_status === 'Pemerintah Daerah' || res.results.data.kepemilikan_status === 'Pemerintah Pusat' || res.results.data.kepemilikan_status === 'Yayasan Swasta' || res.results.data.kepemilikan_status === 'Yayasan keagamaan' ? res.results.data.kepemilikan_status : 'Lainnya'
            this.form.kepemilikan_status_lainnya = res.results.data.kepemilikan_status === 'Pemerintah Daerah' || res.results.data.kepemilikan_status === 'Pemerintah Pusat' || res.results.data.kepemilikan_status === 'Yayasan Swasta' || res.results.data.kepemilikan_status === 'Yayasan keagamaan' ? '' : res.results.data.kepemilikan_status

            this.kepala_sekolah_id = res.results.data.kepala_pegawai_id
            this.operator_pegawai_id = res.results.data.operator_pegawai_id
            this.admin_pendamping_id = res.results.data.admin_pendamping[0].admin_id

            res.results.data.school_galery.map(item => {
              this.form.galery_array.push({
                galery_url: item.school_galery_url,
                galery_desc: item.school_galery_desc
              })
            })
            res.results.data.rekening.map(item => {
              this.form.rekening_array.push({
                rekening_bank_name: item.school_rekening_bank_name,
                rekening_number: item.school_rekening_number,
                rekening_atas_nama: item.school_rekening_atas_nama,
                rekening_cabang_kcp: item.school_rekening_cabang_kcp
              })
            })
            this.center = {
              lat: res.results.data.latitude*1,
              lng: res.results.data.longitude*1
            }
            this.fetchCity(res.results.data.province_id)
            this.fetchSub(res.results.data.city_id)
            this.fetchVillage(res.results.data.subdistrict_id)

            this.process.load = false
          }
        })
      },

      async fetchKurikulum() {

         let params = {
          limit: 10000000000000,
          school_id: this.$route.params.id
        }
        let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? 'pegawai/kurikulum/data' : 'kurikulum/data'

        await get(`${url}`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.kurikulum = res.results.data
          }
        })
      },

      async fetchProv() {

         let params = {
          limit: 10000000000000
        }


        await get(`ref/provinsi`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.province = res.results.data
          }
        })
      },

      changeProvince() {
        this.form.city_id = ''
        this.form.city_name = ''
        this.form.subdistrict_id = ''
        this.form.subdistrict_name = ''
        this.form.village_id = ''
        this.form.village_name = ''
        let id = ''
        this.province.map(obj => {
          if (obj.id === this.form.province_id) {
            id = obj.id
            this.form.province_name = obj.name
          }
        })
        this.fetchCity(id)
      },

      async fetchCity(id) {

         let params = {
          limit: 10000000000000,
          province_id: id
        }

        await get(`ref/kota`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.city = res.results.data
          }
        })
      },

      changeCity() {
        this.form.subdistrict_id = ''
        this.form.subdistrict_name = ''
        this.form.village_id = ''
        this.form.village_name = ''
        let id = ''
        this.city.map(obj => {
          if (obj.id === this.form.city_id) {
            id = obj.id
            this.form.city_name = obj.name
          }
        })
        this.fetchSub(id)
      },

      async fetchSub(id) {

         let params = {
          limit: 10000000000000,
          city_id: id
        }

        await get(`ref/kecamatan`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.subdistrict = res.results.data
          }
        })
      },

      changeSub() {
        this.form.village_id = ''
        this.form.village_name = ''
        let id = ''
        this.subdistrict.map(obj => {
          if (obj.id === this.form.subdistrict_id) {
            id = obj.id
            this.form.subdistrict_name = obj.name
          }
        })
        this.fetchVillage(id)
      },

      async fetchVillage(id) {

         let params = {
          limit: 10000000000000,
          subdistrict_id: id
        }

        await get(`ref/kelurahan`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.village = res.results.data
          }
        })
      },

      setPlace(place) {
        this.place = place
        this.center = {
          lat: this.place.geometry.location.lat(),
          lng: this.place.geometry.location.lng(),
        
        }
          // this.initMap()
        this.form.latitude = this.place.geometry.location.lat()
        this.form.longitude = this.place.geometry.location.lng()
      },
      getGeoLocation() {
        if (this.form.id === '') {
          navigator.geolocation.getCurrentPosition(position => {
            this.center = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            }
          })
        } else {
          this.center = {
            lat: this.form.latitude,
            lng: this.form.longitude
          }
        }
      },
      updatePlace(location) {
        this.center = {
          lat: location.latLng.lat(),
          lng: location.latLng.lng()
        }

        this.form.latitude = location.latLng.lat()
        this.form.longitude = location.latLng.lng()
      },

      async toNextStep  () {
        this.message.error = ''
        this.$refs.form.validate().then(success => {
          if (success) {
            this.step_index = this.step_index + 1
          if (this.$refs.form) this.$refs.form.reset()
          }
        })
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? this.form.id === '' ? 'pegawai/school/add' : 'pegawai/school/update' : this.form.id === '' ? 'school/add' : 'school/update'

          // SAVE TO REST API

          let form = this.form

          form.kepala_sekolah_mobile_phone_number = `${this.form.kepala_sekolah_mobile_phone_number.replace(/^0/, '')}`
          form.operator_sekolah_mobile_phone_number = `${this.form.operator_sekolah_mobile_phone_number.replace(/^0/, '')}`
          form.admin_mobilephone = `${this.form.admin_mobilephone.replace(/^0/, '')}`
          form.akreditasi_status = this.form.akreditasi_status === 'Lainnya' ? this.form.kepemilikan_status_lainnya : this.form.akreditasi_status
          await post(url, {
            data: form
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {

              this.$router.go(-1)

            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      async updateKepala () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? 'pegawai/master/update' : 'pegawai/update'

          // SAVE TO REST API
          await post(url, {
            data: {
              id: this.kepala_sekolah_id,
              name: this.form.kepala_sekolah_name,
              mobile_phone_number: this.form.kepala_sekolah_mobile_phone_number,
              address: this.form.kepala_sekolah_address,
              email: this.form.kepala_sekolah_email,
              school_id: this.form.id,
            }
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {

              this.dialog.snackbar = true
              this.message.success = res.message

            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },
      async updateOperator () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? 'pegawai/master/update' : 'pegawai/update'

          // SAVE TO REST API
          await post(url, {
            data: {
              id: this.operator_pegawai_id,
              name: this.form.operator_sekolah_name,
              mobile_phone_number: this.form.operator_sekolah_mobile_phone_number,
              address: this.form.operator_sekolah_address,
              email: this.form.operator_sekolah_email,
              school_id: this.form.id,
            }
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {

              this.dialog.snackbar = true
              this.message.success = res.message

            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },
      async updateAdmin () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? 'pegawai/admin/update' : 'admin/update'

          // SAVE TO REST API
          await post(url, {
            data: {
              id: this.admin_pendamping_id,
              name: this.form.admin_name,
              mobilephone: this.form.admin_mobilephone,
              email: this.form.admin_email
            }
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {

              this.dialog.snackbar = true
              this.message.success = res.message

            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    },
    created () {
    }
  }
</script>